import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/Modal';
import TermsOfServiceContent from 'containers/TermsOfServiceContent';
import './TermsOfServiceModal.css';

function TermsOfServiceModal(props) {
  const {
    onHide,
    onAccept,
    onLogout,
    closeButton = false,
    buttonText = 'Close',
    acceptBtnText = 'ACCEPT',
    logoutBtnText = 'LOGOUT',
    ...otherProps
  } = props;

  const buttons = (
    <React.Fragment>
      {onAccept && onLogout ? (
        <React.Fragment>
          <button
            onClick={onLogout}
            type="button"
            className="btn button-color-red"
          >
            {logoutBtnText}
          </button>
          <button onClick={onAccept} type="button" className="btn btn-success">
            {acceptBtnText}
          </button>
        </React.Fragment>
      ) : (
        <button
          onClick={onHide}
          type="button"
          className="btn button-color-green"
        >
          {buttonText}
        </button>
      )}
    </React.Fragment>
  );

  return (
    <Modal
      dialogClassName="terms-of-service-modal"
      onHide={onHide}
      {...otherProps}
    >
      <Modal.Header closeButton={closeButton}>TERMS OF SERVICE</Modal.Header>
      <Modal.Body>
        <TermsOfServiceContent />
      </Modal.Body>
      <Modal.Footer>{buttons}</Modal.Footer>
    </Modal>
  );
}

TermsOfServiceModal.propTypes = {
  onHide: PropTypes.func,
  onAccept: PropTypes.func,
  onLogout: PropTypes.func,
  // Modal props
  closeButton: PropTypes.bool,
  show: PropTypes.bool
};

export default TermsOfServiceModal;
